interface IMyLoginCommand {
    phoneNumber: string
}

export const initialValues: IMyLoginCommand = { phoneNumber: '' }
